// Tamaño del área raspable sobre el lienzo de referencia 1080x1920 (no sobre
// window). Compartido entre la pantalla EN VIVO (routes/Raspadita.tsx) y el
// PREVIEW del admin (RaspaditaPreview) -> el preview coincide con la pantalla
// real.
//
// Migration 039: ahora es CONFIGURABLE (deslizadores en Ajustes › Juegos ›
// Raspadita). Estas constantes quedaron como DEFAULT/fallback (= defaults del
// SQL); el valor real llega desde state.global.raspadita_panel_w_px / _h_px
// (vivo) o el form del admin (preview).
//
// Las 3 mecánicas usan el rectángulo PANEL_W x PANEL_H:
// - Panel / Elije: el área raspable es el rectángulo.
// - Grid 3x3: celdas RECTANGULARES (cellW desde W, cellH desde H) -> tanto el
//   ancho como el alto afectan al grid (antes era un cuadrado min(W,H), por lo
//   que el slider de ancho no hacía efecto pasado el alto).
export const RASPADITA_PANEL_W = 640;
export const RASPADITA_PANEL_H = 460;
